import type {Root} from "mdast";
import {visit} from "unist-util-visit";

const directiveClasses = {
    attack: "italic decoration-1",
    dice: "font-bold tabular-nums",
    trait: "ms-2 font-bold italic",
    underline: "underline decoration-1 underline-offset-2",
} as const;

type DireDawnDirective = keyof typeof directiveClasses;

interface TextDirectiveNode {
    type: "textDirective";
    name: string;
    attributes?: Record<string, string | null>;
    data?: {
        hName?: string;
        hProperties?: Record<string, unknown>;
    };
}

export default function remarkDireDawnDirectives() {
    return (tree: Root) => {
        visit(tree, "textDirective", node => {
            const directive = node as TextDirectiveNode;
            if (directive.name === "spell") {
                configureSpellDirective(directive);
                return;
            }
            if (!isDireDawnDirective(directive.name)) return;

            directive.data ??= {};
            directive.data.hName = "span";
            directive.data.hProperties = {
                className: directiveClasses[directive.name],
                "data-diredawn-directive": directive.name,
            };
        });
    };
}

function configureSpellDirective(directive: TextDirectiveNode) {
    const spellId = directive.attributes?.id;
    if (!spellId?.match(/^spell-[a-z0-9]+(?:-[a-z0-9]+)*$/)) return;

    directive.data ??= {};
    directive.data.hName = "a";
    directive.data.hProperties = {
        className: "font-medium underline underline-offset-2",
        href: `#${spellId}`,
        "data-diredawn-directive": "spell",
        "data-spell-id": spellId,
    };
}

function isDireDawnDirective(name: string): name is DireDawnDirective {
    return Object.prototype.hasOwnProperty.call(directiveClasses, name);
}
